@import "../../scss";

.root {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: var(--color-cream);
  -webkit-overflow-scrolling: touch;
  display: flex;
  justify-content: stretch;
  align-items: center;
  padding: 0;
}

.root:global(.enter) {
  opacity: 0;
}

.root:global(.enter-active) {
  transition: opacity 0.3s ease;
  opacity: 1;
}

.root:global(.exit) {
  opacity: 1;
}

.root:global(.exit-active) {
  transition: opacity 0.3s ease;
  opacity: 0;
}

.swiper {
  width: 100%;
  height: 100%;
}

.swiper--autoplay :global(.swiper-wrapper) {
  transition-timing-function: linear;
}

.slide {
  width: 25vw !important;
  height: 100%;

  @include media-breakpoint-down("md") {
    width: 60vw !important;
  }
}
